var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { MultiConsentContext } from '.';
export var MultiConsentProvider = function (_a) {
    var children = _a.children, consents = _a.consents, onComplete = _a.onComplete;
    var _b = __read(useState('None'), 2), asyncStatus = _b[0], setAsyncStatus = _b[1];
    var _c = __read(useState(0), 2), activeConsentIndex = _c[0], setActiveConsentIndex = _c[1];
    var _d = __read(useState(0), 2), focusIndex = _d[0], setFocusIndex = _d[1];
    var _e = __read(useState({}), 2), successByIndex = _e[0], setSuccessByIndex = _e[1];
    var showNextConsent = function () {
        var _a;
        if (activeConsentIndex < consents.length - 1) {
            setActiveConsentIndex(activeConsentIndex + 1);
            setFocusIndex(activeConsentIndex + 1);
            var newSuccessByIndex = __assign(__assign({}, successByIndex), (_a = {}, _a[activeConsentIndex] = true, _a));
            setSuccessByIndex(newSuccessByIndex);
        }
        else {
            onComplete();
        }
    };
    var initialValue = {
        activeConsentIndex: activeConsentIndex,
        setActiveConsentIndex: setActiveConsentIndex,
        asyncStatus: asyncStatus,
        setAsyncStatus: setAsyncStatus,
        showNextConsent: showNextConsent,
        focusIndex: focusIndex,
        successByIndex: successByIndex,
    };
    return (React.createElement(MultiConsentContext.Provider, { value: initialValue }, children));
};
//# sourceMappingURL=MultiConsentProvider.js.map